<template>
  <div class="history-change" @click="$emit('clickHistoryIcon')">
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M30.0006 0.833984C26.1704 0.833984 22.3777 1.5884 18.839 3.05416C15.3004 4.51993 12.0851 6.66833 9.3767 9.3767C3.90689 14.8465 0.833984 22.2652 0.833984 30.0006C0.833984 37.7361 3.90689 45.1548 9.3767 50.6246C12.0851 53.333 15.3004 55.4814 18.839 56.9471C22.3777 58.4129 26.1704 59.1673 30.0006 59.1673C37.7361 59.1673 45.1548 56.0944 50.6246 50.6246C56.0944 45.1548 59.1673 37.7361 59.1673 30.0006C59.1673 26.1704 58.4129 22.3777 56.9471 18.839C55.4814 15.3004 53.333 12.0851 50.6246 9.3767C47.9162 6.66833 44.7009 4.51993 41.1623 3.05416C37.6236 1.5884 33.8309 0.833984 30.0006 0.833984ZM42.2507 42.2507L27.084 32.9173V15.4173H31.459V30.584L44.584 38.459L42.2507 42.2507Z" fill="black" fill-opacity="0.54"/>
    </svg>
    <div class="history-change__counter">
      {{ count }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'HistoryChangeIcon',
  props: {
    count: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.history-change {
  position: relative;
  cursor: pointer;

  &__counter {
    position: absolute;
    bottom: -14px;
    right: -8px;
    @include flex-center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    color: #FFFFFF;
    font-weight: 600;
    font-size: 26px;
    line-height: 22px;
    background-color: #1BA6DA;
  }
}

</style>
